module.exports = __webpack_public_path__ + "static/03-b53150275367ca605d764ab54f1109cd.jpg";